/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Interestedproducts1Inputs */

const de__field_interestedproducts1 = /** @type {(inputs: _Field_Interestedproducts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktinteressen`)
};

/**

* @param {_Field_Interestedproducts1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_interestedproducts1 = /** @type {((inputs?: _Field_Interestedproducts1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Interestedproducts1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_interestedproducts1(inputs)
});
export { _field_interestedproducts1 as "_field_interestedProducts" }